import { apiFetch } from '@ami/react/core';

export class GeoCountry {
  constructor(item) {
    this.label = item.label;
    this.countryCode = item.countryCode;
  }

  static async all() {
    const entities = await apiFetch('geo-locations/countries');
    return entities.map((x) => new GeoCountry(x));
  }
}
